/**
 * OVERRIDE SlotDate.tsx
 * FILE: @plone-collective/volto-techevent/src/components/Schedule/SlotDate.tsx
 * DATE: 2026-09-14
 *
 * CHANGES vs. upstream:
 *
 * 1. ICS download button after the end time
 *    Renders IcsDownloadButton (from @plone/conf-core) inside
 *    `.slotDate .wrapper`, right after the end-time element. SlotDate is
 *    shared by SessionMetadata, so the icon shows up in schedule-block
 *    tiles (SessionTile/SlotTile) and on the Meeting / Lightning Talks /
 *    Break / Slot views without touching those components.
 *
 * 2. Favorite star toggle after the ICS button
 *    Renders FavoriteToggle (from @plone/conf-core) for logged-in users.
 *
 * Everything else is identical to the upstream file.
 */

import React from 'react';
import { formatDate } from '@plone/volto/helpers/Utils/Date';
import IcsDownloadButton from '@plone/conf-core/components/IcsDownload/IcsDownloadButton';
import FavoriteToggle from '@plone/conf-core/components/Favorites/FavoriteToggle';

function formatHour(value, locale) {
  return value.toLocaleTimeString(locale, {
    hour: '2-digit',
    minute: '2-digit',
  });
}

const ShortFormat = ({ item, start, end, locale }) => (
  <>
    <time className="start" dateTime={item.start}>
      {formatHour(start, locale)}
    </time>{' '}
    –{' '}
    <time className="end" dateTime={item.end}>
      {formatHour(end, locale)}
    </time>
  </>
);

const LongFormat = ({ item, start, end, locale }) => {
  const date = formatDate({ date: start, locale: locale, includeTime: false });
  return (
    <>
      <span className="date">{date}</span> –{' '}
      <time className="start" dateTime={item.start}>
        {formatHour(start, locale)}
      </time>{' '}
      –{' '}
      <time className="end" dateTime={item.end}>
        {formatHour(end, locale)}
      </time>
    </>
  );
};

const SlotDate = ({ item, shortFormat, className, locale }) => {
  const start = item.start !== null ? new Date(item.start) : null;
  const end = item.end !== null ? new Date(item.end) : null;
  const isValid = !isNaN(start?.getTime()) && !isNaN(end?.getTime());

  return (
    <div className={`slotDate ${className || ''}`.trim()}>
      {isValid && (
        <div className="wrapper">
          {shortFormat ? (
            <ShortFormat item={item} start={start} end={end} locale={locale} />
          ) : (
            <LongFormat item={item} start={start} end={end} locale={locale} />
          )}
          <IcsDownloadButton item={item} />
          <FavoriteToggle uid={item.UID} />
        </div>
      )}
    </div>
  );
};

export default SlotDate;
